export { default } from "./post-template"

// TODO export query when migration away from @reflexjs is complete... but will this work?
